import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

import { observer } from "mobx-react-lite";
import { NoEventStats } from "../../data/models/stats";
import { capitalizeFirstLetter } from "../../utils/utils";
import { useTranslation } from "react-i18next";
import { genderOptions, getGenderOptions } from "../../data/static/user";


interface GenderSpecificNumberOfClientsProp {
    data: NoEventStats[];
}

function GenderSpecificNumberOfClientsTable({ data }: GenderSpecificNumberOfClientsProp) {
    const { t } = useTranslation();

    const genders = getGenderOptions(t);

    return (
        <TableContainer component={Paper} sx={{ bgcolor: "#fff" }}>
            <Table sx={{ minWidth: 650 }} aria-label="caption table">
                <TableHead>
                    <TableRow>
                        {genders.map((gender) =>
                            <TableCell key={gender.value} sx={{ textAlign: "center" }}>{gender.label}</TableCell>
                        )}
                        <TableCell sx={{ textAlign: "center" }}>{t("CARD_TOTAL_GENDER")}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        {data.map((row) =>
                            <TableCell key={row.gender} sx={{ textAlign: "center" }}>{row.total}</TableCell>
                        )}
                        <TableCell sx={{ textAlign: "center", bgcolor: "#ffc10726", fontWeight: 600 }}>
                            {data.reduce((acc, result) => {
                                return acc + result.total;
                            }, 0)}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default observer(GenderSpecificNumberOfClientsTable);